export default __webpack_public_path__ + "static/media/adminDefaultImgCropped.2083e7a2.jpg";